import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Truck } from "../../../types";
import { updateEntryLicensePlate } from "../../../utils/api";

interface LicensePlateEditModalProps {
  open: boolean;
  onClose: () => void;
  truck: Truck | Truck[];
  onLicensePlateChange?: (truck: Truck, newLicensePlate: string) => void;
}

export function LicensePlateEditModal({
  open,
  onClose,
  truck,
  onLicensePlateChange,
}: LicensePlateEditModalProps): React.JSX.Element {
  const [licensePlate, setLicensePlate] = React.useState<string>("");
  const truckToUse = Array.isArray(truck) ? truck[0] : truck;

  React.useEffect(() => {
    if (truckToUse) {
      setLicensePlate(truckToUse.registration || "");
    }
  }, [truckToUse]);

  const handleSave = async () => {
    try {
      await updateEntryLicensePlate(truckToUse.id, licensePlate);

      if (onLicensePlateChange) {
        onLicensePlateChange(truckToUse, licensePlate);
      }

      onClose();
    } catch (error) {
      console.error("Error updating truck license plate:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontFamily: "SigmaSans" }}>
        Edit License Plate - {truckToUse?.registration}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Change the license plate for this vehicle.
        </DialogContentText>
        <TextField
          fullWidth
          label="License Plate"
          value={licensePlate}
          onChange={(e) => setLicensePlate(e.target.value)}
          variant="outlined"
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
